<template lang="pug">
  div.c-wrap.polls-nav(v-if="polls.length && page !== 'finish'")
    paginate(
      v-model="forcePage"
      :page-count='totalPages'
      :click-handler='pageChange'
      :prev-text="'Назад'"
      :next-text="'Вперед'"
      :container-class="'polls-pag'"
      :page-link-class="'polls-pag__btn'"
      :next-link-class="'btn-sec polls-pag__btn-next'"
      :prev-link-class="'btn-sec polls-pag__btn-prev'"
      :active-class="'is-current'"
      :disabled-class="'is-hidden'"
      :no-li-surround="true"
      :hide-prev-next="false")
    btn.send-polls-action(:txt="'Отправить'" :event="'sendAnswers'" v-show="showSendButton")
</template>

<script>
  // vendor
  import _find from 'lodash/find';
  import _filter from 'lodash/filter';

  // components
  import PrimaryButton from '@/components/UI/Button/Button.vue'

  export default {
    name: 'PollsNav',
    components: {
      'btn': PrimaryButton
    },
    computed: {
      polls () {
        return this.$store.state.polls.polls.filter((item) => {
          return item.elements.length;
        })
      },
      unvalidPolls () {
        return this.$store.state.polls.unvalidPolls;
      },
      totalPages () {
        return this.polls.length
      },
      showSendButton () {
        // получен опросы О компании, детальные сведения о компании
        // больше 4 опросов, т.е. кроме сведений о компании и списка опросов выбрали еще что-то в этом списке
        // ну и находимся на последней странице опросов
        let { polls } = this.$store.state;
        return polls.isFetchedCompanyPolls && this.totalPages === this.currentPage && polls.polls.length > 3;
      },
      page () {
        return this.$route.name
      },
      currentPollComponents () {
        return _filter(this.$store.state.polls.pollComponent, (item) => {
          return !item.condition || item.condition.resolved === true;
        });
      }
    },
    methods: {
      setPoll () {
        const pollId = this.polls[this.currentIdx].id
        this.$store.dispatch('polls/setCurrentPollById', pollId)
        this.currentPoll = pollId
      },
      pageChange (page) {
        if (page > this.currentPage) {
          this.forcePage = this.currentPage

          for (let i = 0; i < this.currentPollComponents.length; i++) {
            if (this.currentPollComponents[i].validator) {
              this.currentPollComponents[i].validator()
            }
          }

          if (_find(this.currentPollComponents, { 'hasError': true })) {
              if (page <= 3) return false;
          } else this.$store.dispatch('polls/removeUnvalidPoll', this.polls[this.currentIdx].id);
        }

        this.forcePage = page
        this.currentPage = page
        this.currentIdx = page - 1
        this.setPoll()
      }
    },
    mounted () {
      this.$on('sendAnswers', () => {
        for (let i = 0; i < this.currentPollComponents.length; i++) {
          if (this.currentPollComponents[i].validator) {
            this.currentPollComponents[i].validator()
          }
        }

        if (_find(this.currentPollComponents, { 'hasError': true })) {
          return false
        }

        this.checkPages = true;
        this.$store.dispatch('polls/removeUnvalidPoll', this.polls[this.currentIdx].id)
        this.$store.dispatch('polls/colorizeFailedPages', {
          'polls': this.polls,
          'unvalidPolls': this.unvalidPolls
        });

        if (this.unvalidPolls.length > 0) {
          this.$modal.show('dialog', {
            title: '',
              text: 'Дайте ответы на обязательные вопросы, помеченные звездочкой *',
              buttons: [
                {
                  title: 'Ок',
                  handler: () => {
                    let firstErrorPage = this.polls.indexOf(_find(this.polls, { 'id': this.unvalidPolls[0] })) + 1;
                    this.pageChange(firstErrorPage);
                    this.$modal.hide('dialog');
                  }
                },
                {
                  title: 'Отмена'
                }
                ]
            });

            return false;
        }

        this.$store.dispatch('answers/sendAnswers').then((result) => {
          this.$router.push('/finish')
        })
      })
    },
    updated () {
      if (this.checkPages) {
        this.$store.dispatch('polls/colorizeFailedPages', {
          'polls': this.polls,
          'unvalidPolls': this.unvalidPolls
        });
      }
    },
    data () {
      return {
        currentIdx: 0,
        currentPage: 1,
        forcePage: 1,
        currentPoll: {},
        checkPages: false
      }
    }
  }
</script>

<style lang="scss" src="./assets/polls-nav.scss"></style>
